// extracted by mini-css-extract-plugin
export default {"select":"DatePickerWrapper_select__lj-xQ"};